import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { MessageRefreshPage } from '@core/constants/messages';
import { SdohSubmissionStatus } from '@core/model';
import { MessageService } from 'primeng/api';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AssessmentService } from '../service/assessment.service';

@Injectable({
  providedIn: 'root'
})
export class AccessDataEditGuard {
  constructor(
    private readonly assessmentService: AssessmentService,
    private readonly messageService: MessageService
  ) { }

  canActivate(next: ActivatedRouteSnapshot): Observable<boolean> {
    const referralId = next.params['rId'];
    const submissionId = next.params['sId'];
    const queryString = `?$top=10&$skip=0&$filter=referralId eq ${referralId}`;

    return this.assessmentService.getReferrals(queryString).pipe(
      map(res => {
        const submission = res?.items[0]?.submissions?.find(
          el => el.referralSubmissionId === submissionId
        );
        if (res.items.length && submission?.status !== SdohSubmissionStatus.InternalReview) {
          // pass referral data to component by route data, to prevent dublicated call in resolver
          next.data = { ...next.data, referral: res.items[0] };
          return true;
        } else {
          this.messageService.add({
            key: 'sdohToastMessage',
            severity: 'warn',
            summary: 'Warning',
            detail: MessageRefreshPage,
            life: 5000
          });
          return false;
        }
      })
    );
  }
}
